<template>

	<div class="page-bar">

		<breadcrumb :pages="pages" />
		<available-languages v-if="languages" />

	</div>

</template>

<script>

	import PageBar from './';
	export default PageBar;

</script>



// WEBPACK FOOTER //
// page-bar.vue?99c97534